import { promiseDecoratorQ } from './promise.q';
import { promiseDecoratorHttp } from './promise.http';

export default angular
  .module('ng1-promise-decorator', [])
  .config(promiseDecoratorQ)
  .config(promiseDecoratorHttp)
  .name;
